import React from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import CustomSwitchToggle from "../../../components/common/Switch";
import SelectField from "../../../newComponents/form-fields/SelectField";
import "./ManageAutoPayForm.css";

export interface ManageAutoPayFormProps {
  formId: string;
  onSubmit: (values: any) => void | Promise<void>;
  accountOptions: { Id: number; Name: string }[];
  infoText: string;
}

const ManageAutoPayForm: React.FC<ManageAutoPayFormProps> = ({
  formId,
  onSubmit,
  accountOptions,
  infoText,
}) => {
  const { control, handleSubmit } = useFormContext();
  const isEnabled = useWatch({ control, name: "isEnabled" }) === "true";

  return (
    <form
      id={formId}
      className="manage-auto-pay-form"
      onSubmit={handleSubmit(onSubmit)}
    >
      <p className="manage-auto-pay-form__info-text">{infoText}</p>

      <div className="manage-auto-pay-form__toggle-group">
        <Controller
          name="isEnabled"
          control={control}
          render={({ field }) => (
            <CustomSwitchToggle
              label="Auto Pay"
              checked={field.value === "true"}
              onClick={(e) => field.onChange(e.target.checked ? "true" : "false")}
            />
          )}
        />
      </div>

      <div className="manage-auto-pay-form__field">
        <SelectField
          name="plaidAccountId"
          label="Select Plaid Account"
          required={isEnabled}
          requiredMessage="Please select a Plaid account"
          options={accountOptions}
          placeholderText="Select"
        />
      </div>
    </form>
  );
};

export default ManageAutoPayForm;
